import { Language } from "imports/Utils";
import { intl } from "LocaleWrapper";
import { PageHeader } from "@cofano/cck";
import Helmet from "components/helmet/Helmet";
import { TableId } from "components/table";
import InvoiceLinesTable from "./components/table/InvoiceLinesTable";

const Invoicing = () => (
	<div>
		<PageHeader>
			<PageHeader.Title>
				{Language("ADMINISTRATION_INVOICING")}
				<Helmet title={intl.formatMessage({ id: "ADMINISTRATION_INVOICING" })} />
			</PageHeader.Title>
		</PageHeader>

		<InvoiceLinesTable tableId={TableId.InvoiceLines} />
	</div>
);

export default Invoicing;
